import { h, Fragment } from "preact";

import { Box, Button, Typography, Tooltip } from "@mui/material";

import { useContext } from "preact/hooks";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from '@mui/icons-material/Edit';
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { AppContext } from "../../AppContext";
import palette from "../../theme/palette";
import IconButton from '@mui/material/IconButton';


export default function ProxiedCard({ proxied, mode, target }) {
    const app = useContext(AppContext);

    if (!(proxied && proxied.length > 0)) { return false; }

    return (
        <div style={{ backgroundColor: "#F4F4F4" }}>

            {proxied && proxied.length > 0 && <Typography variant="body1" style="margin-top: 10px;"><em>Représente</em></Typography>}

            {proxied && proxied.map((prx, idx) => (
                <Box display="flex" alignItems="center" justifyContent="space-between" >

                    <Box>
                        <Typography variant="body1" >
                            {prx.n}{idx < (proxied.length - 1) ? "," : ""}&nbsp;
                        </Typography>
                        {prx.a && <Typography variant="body2" >{prx.a}</Typography>}
                    </Box>

                    <Box  >
                        {target == mode && <IconButton
                            size={"small"}
                            variant="contained"
                            onClick={() => app.refPopUp.current.handleChangeState(
                                {
                                    opened: true,
                                    type: "041",
                                    params: {
                                        prx: prx
                                    }
                                }
                            )}>
                            <EditIcon size={"small"} />
                        </IconButton>}
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="flex-start">
                        <Box  >
                            <Tooltip title={"Profil utilisateur complet"}>
                                <AccountCircleIcon
                                    style={{
                                        color: prx.user_data ? palette.success.main : palette.warning.main,
                                    }}
                                />
                            </Tooltip>
                        </Box>
                        {target == "VN" && <Box >
                            <Tooltip title={prx.hsm ? "Mandat signé" : "Mandat en attente de signature"}>
                                <FingerprintIcon
                                    style={{
                                        color: prx.hsm ? palette.success.main : palette.warning.main,
                                    }}
                                />
                            </Tooltip>
                        </Box>}
                        <Box >
                            <Tooltip title={prx.hso ? "Offre signée" : "Offre en attente de signature"}>
                                <FingerprintIcon
                                    style={{
                                        color: prx.hso ? palette.success.main : palette.warning.main,
                                    }}
                                />
                            </Tooltip>

                        </Box>
                    </Box>
                </Box>
            ))}
        </div>

    )

}